// extracted by mini-css-extract-plugin
export default {"root":"ApprovedRequestsTable_root__1hr-n","rows":"ApprovedRequestsTable_rows__EZsJw","pagination":"ApprovedRequestsTable_pagination__ZY5UJ"};